"use client";

import { globalStyleObj } from "@/app/assets/styles";
import { useTheme } from "next-themes";
import dynamic from "next/dynamic";
import { LabelText } from "..";
import { Skeleton } from "../ui/skeleton";
import { editorOptions } from "@/app/assets/data/sun-editor-setting";
import { useCallback, useRef } from "react";

const JoditEditor = dynamic(
  () => import("jodit-react"),
  { ssr: false } // This is key
);

const NormalTextEditorInputFiled = ({
  isFetching = false,
  labelText = "",
  fieldId = "unknown",
  fieldName = "unknown",
  placeholderText = "",
  inputValue = "",
  toolbarButtons = "",
  onChangeTextEditorFiled,
  extraFiledInfo = "",
  extraContainerClasses = "",
  extraInputClasses = "",
  textEditorMaxWidth = "lg:max-w-[500px]",
  translateField = false,
}) => {
  const editor = useRef(null);
  const { theme } = useTheme();

  // Debounced change handler
  const handleChange = useCallback(
    (newContent) => {
      // Basic XSS prevention
      const cleanContent = newContent
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
        .replace(/javascript:/gi, "")
        .replace(/on\w+\s*=/gi, "");

      onChangeTextEditorFiled(cleanContent, fieldName);
    },
    [onChangeTextEditorFiled, fieldName]
  );

  return (
    <div
      className={`${extraContainerClasses} ${globalStyleObj.commonSettingInputContainerClass}`}
    >
      {isFetching ? (
        <>
          {labelText && <Skeleton className="w-[150px] h-[30px] rounded-md" />}
          <Skeleton className="w-full lg:max-w-[500px] h-[250px] rounded-md" />
        </>
      ) : (
        <>
          {labelText && (
            <LabelText
              text={labelText}
              htmlForId={fieldId}
              translateField={translateField}
            />
          )}

          <div
            className={`w-full rounded-sm border border-[#000]/20 dark:border-[#fff]/10 ${textEditorMaxWidth} ${theme === "dark" ? "jodit-dark" : "jodit-light"}`}
          >
            <JoditEditor
              ref={editor}
              id={fieldId}
              value={inputValue}
              name={fieldName}
              onChange={handleChange}
            />

            {extraFiledInfo && (
              <p className="text-[10px] font-poppins-rg text-light-weight-400 mt-1">
                {extraFiledInfo}
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NormalTextEditorInputFiled;
